import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doctor2_diagnosis-enter-disease-erke",
  "use": "icon-doctor2_diagnosis-enter-disease-erke-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 22\" id=\"icon-doctor2_diagnosis-enter-disease-erke\">\r\n  <g transform=\"translate(-654 -820)\">\r\n    <path class=\"a\" d=\"M76.5,109.561a1.665,1.665,0,0,0-.959-1.508,10,10,0,0,0-20-.039,1.665,1.665,0,0,0,.463,3.2,10,10,0,0,0,19.075-.01A1.662,1.662,0,0,0,76.5,109.561Zm-11.547-9.313a.475.475,0,1,1,0-.949,2.846,2.846,0,0,1,0,5.692.475.475,0,1,1,0-.949,1.9,1.9,0,0,0,0-3.793Zm-3.622,10.313a1,1,0,1,1,1-1A1,1,0,0,1,61.331,110.561Zm4.21,4.552a2.858,2.858,0,0,1-2.858-2.858H68.4A2.854,2.854,0,0,1,65.541,115.113Zm4.212-4.552a1,1,0,1,1,1-1A1,1,0,0,1,69.753,110.561Z\" transform=\"translate(599.5 722.757)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/doctor2_diagnosis-enter-disease-erke.svg
// module id = 9pjX
// module chunks = 10